import { Component, OnInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FirestoreService } from 'src/app/services/firestore.service';
import { StorageService } from 'src/app/services/storage.service';

import { RichTextEditorService } from '../../services/rich-text-editor.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { LoadingModalService } from 'src/app/services/loadingmodal.service';


@Component({
  selector: 'app-admin-business-detail',
  templateUrl: './admin-business-detail.component.html',
  styleUrls: ['./admin-business-detail.component.sass']
})
export class AdminBusinessDetailComponent implements OnInit {
  uid;

  businessDocId;
  businessDoc;
  businessCategoryCol;

  coverPicture: string = "./assets/img/no-cover.png";
  profilePicture: string = "./assets/img/no-logo.png";
  profilePictureCol;
  coverPictureCol;

  // Upload Picture File
  pictureUpload;
  activeProfilePictureUrl;

  //Forms
  updateAboutForm;
  updateContactForm;
  addLocationForm: FormGroup;
  updateLocationForm;
  addProductForm: FormGroup;
  updateProductForm;
  addTeamForm: FormGroup;
  updateTeamForm;
  addJobForm: FormGroup;
  updateJobForm; 

  text: string = '';
  editorConfig: AngularEditorConfig;
  uploadProgress: number = 0;

  profilePictureColDocLenght;
  coverPictureColDocLenght;

  constructor(
    private fb : FormBuilder,
    public db: FirestoreService,
    public auth: AuthenticationService,
    public storage: StorageService,
    public afAuth: AngularFireAuth,
    public afDd: AngularFirestore,
    public route: Router,
    private modalService: NgbModal,
    config: NgbModalConfig,
    public aRoute: ActivatedRoute,

    private elementRef: ElementRef,
    private editorService: RichTextEditorService,
    private loadingModalService: LoadingModalService

    ) {
      this.editorConfig = editorService.editorConfig;
    }

    
      
    onTextChanged(event: any) {
      // Handle text changes here
    }
  
    // Example usage of pastePlainText method
    onKeyDown(event: KeyboardEvent): void {
      this.editorService.handleKeyDownEvent(event);
    }

    onPaste(event: ClipboardEvent): void {
      this.editorService.handlePasteEvent(event);
    }

  ngOnInit(): void {
    
    this.businessDocId = this.aRoute.snapshot.paramMap.get('id')
    this.businessDoc = this.db.getMainDoc('businesses', this.businessDocId);
    // console.log('this.docId: '+this.businessDocId);   
    this.businessCategoryCol = this.db.getMainCol('businessCategories');

    this.profilePictureCol = this.db.getSubColLimit(10, 'businesses', this.businessDocId, 'profilePictures');
    this.coverPictureCol = this.db.getSubColLimit(10, 'businesses', this.businessDocId, 'coverPictures');
    // this.db.getSubColDocLenght('businesses', this.businessDocId, 'profilePictures')
    //   .snapshotChanges()
    //   .subscribe(query=>{
    //   this.profilePictureColDocLenght = query.length;
    //   });
    //   this.db.getSubColDocLenght('businesses', this.businessDocId, 'coverPictures')
    //   .snapshotChanges()
    //   .subscribe(query=>{
    //   this.coverPictureColDocLenght = query.length;
    //   });


    this.updateAboutForm = this.fb.group({
      name:'',
      category:'',
      about:'',      
      dateUpdated: Date.now(),
    })
    this.updateContactForm = this.fb.group({
      phone: '',
      email: '',
      websiteUrl: '',
      postal: '', 
      socialLinkedinUrl:'',
      socialWhatsappPhone:'',
      socialTwitterUrl:'',
      socialFacebookUrl:'',      
      dateUpdated: Date.now(),
    })

    this.addLocationForm = this.fb.group({
      name:'',
      address:'',
      latitude:'',
      longitude:'',
      colId: 'locations',
      dateUpdated: Date.now(),
      dateCreated: Date.now(),
      creatorUid: this.uid 
    })
    this.updateLocationForm = this.fb.group({
      name:'',
      address:'',
      latitude:'',
      longitude:'',
      dateUpdated: Date.now(),
      userUpdated: this.uid
    })

    

  }

  reloadComponent() {
    let currentUrl = this.route.url;
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.onSameUrlNavigation = 'reload';
    this.route.navigate([currentUrl]);
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });    
  }

  routToLogin(){
    this.db.getArrayValue('businesses', this.businessDocId, this.uid)
  }

  openSpinnerModal(content){
    this.modalService.open(content);
    setTimeout(() => {
      this.modalService.dismissAll();
    }, 5000); 
  }

  // Profile Picture
  addProfilePictureDoc(e, spinnerModalContent){
    this.pictureUpload = e.target.files[0];
    if(this.pictureUpload != undefined){   
      // Open Modal
      this.modalService.open(spinnerModalContent);   
      this.storage.uploadFileSubSubFolderSubCol(this.pictureUpload, 'profilePictureUrl', 'pictureUrl', 'businesses', this.businessDocId, 'profilePictures')
      .subscribe(progress =>{
        this.uploadProgress = progress
        // Close Modal
        if(this.uploadProgress == 100){
          setTimeout(() => {
            this.modalService.dismissAll();
          }, 3000);
        }
      })
    }

  }
  updateProfilePictureDoc(pictureUrl){
    this.db.updateMainDocField('businesses', this.businessDocId, 'profilePictureUrl', pictureUrl)
    .then(res =>{
      this.reloadComponent();
    })
  }
  deleteProfilePictureDoc(docid, pictureUrl){
    this.storage.deleteFile(pictureUrl)
    .then(res =>{
      this.db.deleteSubDoc('businesses', this.businessDocId, 'profilePictures', docid)
    })
  }
  
  // Cover Picture
  addCoverPictureDoc(e, spinnerModalContent){
    
    this.pictureUpload = e.target.files[0];
    if(this.pictureUpload != undefined){
      // Open Modal
      this.modalService.open(spinnerModalContent);
      this.storage.uploadFileSubSubFolderSubCol(this.pictureUpload, 'coverPictureUrl', 'pictureUrl', 'businesses', this.businessDocId, 'coverPictures')
      .subscribe(progress =>{
        this.uploadProgress = progress
        // Close Modal
        if(this.uploadProgress == 100){
          setTimeout(() => {
            this.modalService.dismissAll();
          }, 3000);
        }
      })
    }
  }
  updateCoverPictureDoc(pictureUrl){
    this.db.updateMainDocField('businesses', this.businessDocId, 'coverPictureUrl', pictureUrl)
    .then(res =>{
      this.reloadComponent();
    })
  } 
  deleteCoverPictureDoc(docid, pictureUrl){
    this.storage.deleteFile(pictureUrl)
    .then(res =>{
      this.db.deleteSubDoc('businesses', this.businessDocId, 'coverPictures', docid)
    })
  }

  // Update About
  closeUpdateAboutModalForm(){
    this.modalService.dismissAll()
    this.updateAboutForm.reset()
  }
  openUpdateAboutModalForm(content) {
    this.modalService.open(content);
  }
  updateAboutField(formValues){
    this.db.updateMainDoc(formValues, 'businesses', this.businessDocId)    
    .then(res =>{
      this.closeUpdateAboutModalForm()
    })
  }
  // Update Contact
  closeUpdateContactModalForm(){
    this.modalService.dismissAll()
    this.updateAboutForm.reset()
  }
  openUpdateContactModalForm(content) {
    this.modalService.open(content);
  }
  updateContactField(formValues){
    this.db.updateMainDoc(formValues, 'businesses', this.businessDocId)    
    .then(res =>{
      this.closeUpdateAboutModalForm()
    })
  }

  // route
  routeToHomePage(){
    this.route.navigate(['']);
  }
  routeToPeopleDetailsUpdatePage(){
    this.route.navigate(['people/update/details']);
  }


}
